import { reactive, inject } from 'vue'

export function createToast() {
  const items = reactive([])
  let audioCtx

  function beep() {
    try {
      audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)()
      const osc = audioCtx.createOscillator()
      const gain = audioCtx.createGain()
      osc.type = 'sine'
      osc.frequency.value = 880
      gain.gain.setValueAtTime(0.001, audioCtx.currentTime)
      gain.gain.exponentialRampToValueAtTime(0.2, audioCtx.currentTime + 0.05)
      gain.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + 0.4)
      osc.connect(gain)
      gain.connect(audioCtx.destination)
      osc.start()
      osc.stop(audioCtx.currentTime + 0.4)
    } catch (e) { void 0 }
  }

  function remove(id) {
    const i = items.findIndex(t => t.id === id)
    if (i !== -1) items.splice(i, 1)
  }

  function show({ text, title, type = 'info', duration = 3500 }) {
    const id = Date.now() + Math.random()
    items.push({ id, text, title, type })
    beep()
    setTimeout(() => remove(id), duration)
  }

  return { items, show, remove }
}

export function useToast() {
  return inject('toast')
}
